import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import getWithdrawals from './getWithdrawals';
import { TA_GET_WITHDRAWALS } from 'app/constants';

export default function* watchSalesBalance() {
  yield fork(takeLatest, TA_GET_WITHDRAWALS, getWithdrawals);
}
